/* jshint node:true */
var React               = require('react');
var Router              = require('react-router');
var StoreMixin          = require('fluxible/addons/FluxibleMixin');
var loadScores          = require('../../../actions/loadScores');

//var GameHeader = require('./header.jsx');
//var GameStats = require('./stats.jsx');
//var GameInfo = require('./info.jsx');
//var GameTeamTable = require('./teamTable.jsx');



var TabLinks            = require('./TabLinks.jsx');
var TabSummary          = require('./TabSummary.jsx');
var TabMatchStats       = require('./TabMatchStats.jsx');
var TabPlayerStats      = require('./TabPlayerStats.jsx');
var TabTable            = require('./TabTable.jsx');
var TabLineup           = require('./TabLineup.jsx');
var TabConversation     = require('./TabConversation.jsx');
var TabCommentary       = require('./TabCommentary.jsx');
var TabArticle          = require('./TabArticle.jsx');
var GameStrip           = require('../../scoreboard/game-strip/GameStrip.jsx');

var Game = React.createClass({

    displayName: 'Game',

    getInitialState: function () {
        return {
            matchView: 'summary', // report, commentary, matchstats, playerstats, lineups, table, conversation
            width: this.getWidth()
        };
    },

    componentDidMount: function() {
        window.addEventListener('resize', this.throttle(this.handleResize, 150));
        this.handleResize();
    },

    componentWillUnmount: function() {
        window.removeEventListener('resize', this.handleResize);
    },

    getWidth:function(){
        return jQuery(window).outerWidth();
    },

    handleResize: function(){
         this.setState({
            width: this.getWidth()
         });
    },

    throttle : function(callback, limit) {
        var wait = false;
        return function () {
            if (!wait) {
                callback.call();
                wait = true;
                setTimeout(function () {
                    wait = false;
                }, limit);
            }
        };
    },

    render: function () {

        var rMatchView  = null;
        var sState      = this.props.matchState;

        //var node = React.findDOMNode (this.refs.scrollbar)
        //node.scrollHeight - this.scrollHeight

        var oStandingsStore = this.props.context.getStore('ScoreStore');

        if(this.props.matchView === 'commentary'){
            rMatchView = (
                <TabCommentary tableHref={this.props.tableHref} store={oStandingsStore} matchState={sState} width={this.state.width} />
            );
        }else if(this.props.matchView === 'matchstats'){
            rMatchView = (
                <TabMatchStats tableHref={this.props.tableHref} store={oStandingsStore} matchState={sState} width={this.state.width} />
            );
        }else if(this.props.matchView === 'playerstats'){
            rMatchView = (
                <TabPlayerStats tableHref={this.props.tableHref} store={oStandingsStore} matchState={sState} width={this.state.width} />
            );
        }else if(this.props.matchView === 'lineups'){
            rMatchView = (
                <TabLineup tableHref={this.props.tableHref} store={oStandingsStore} matchState={sState} width={this.state.width} />
            );
        }else if(this.props.matchView === 'table'){
            rMatchView = (
                <TabTable store={oStandingsStore} matchState={sState} width={this.state.width} />
            );
        }else if(this.props.matchView === 'conversation'){
            rMatchView = (
                <TabConversation query={this.props.query} tableHref={this.props.tableHref} store={oStandingsStore} width={this.state.width} />
            );
        }else if(this.props.matchView === 'report' || this.props.matchView === 'recap' || this.props.matchView === 'preview'){
            rMatchView = (
                <TabArticle query={this.props.query} tableHref={this.props.tableHref} store={oStandingsStore} width={this.state.width} />
            );
        }else{
            rMatchView = (
                <TabSummary query={this.props.query} tableHref={this.props.tableHref} store={oStandingsStore} matchState={sState} changeView={this.props.changeView} width={this.state.width} />
            );
        }

        return (
            <section id="reactContainer">
                {rMatchView}
            </section>
        );
    }
});

module.exports = Game;



/** WEBPACK FOOTER **
 ** C:/gitrepos/espn-react-app/app/components/rugby/game/index.jsx
 **/